import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';

const webClientId = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID || '';
const iosClientId = process.env.REACT_APP_GOOGLE_IOS_CLIENT_ID || '';

let initPromise;

/**
 * Initialize Capgo SocialLogin once with every provider we use.
 * Calling initialize({ apple }) after initialize({ google }) replaces config
 * and breaks the other provider (dead buttons after the first attempt).
 */
export function ensureSocialLoginInitialized() {
  if (!Capacitor.isNativePlatform()) {
    return Promise.reject(new Error('SocialLogin is only available on native'));
  }
  if (initPromise) return initPromise;

  const config = {};
  if (webClientId) {
    config.google = {
      webClientId,
      iOSClientId: iosClientId || webClientId,
      iOSServerClientId: webClientId,
      mode: 'online',
    };
  }
  if (Capacitor.getPlatform() === 'ios') {
    config.apple = { redirectUrl: '' };
  }

  if (!Object.keys(config).length) {
    return Promise.reject(new Error('No SocialLogin providers configured'));
  }

  initPromise = SocialLogin.initialize(config).catch((err) => {
    initPromise = undefined;
    throw err;
  });
  return initPromise;
}
